export default "__VITE_ASSET__AatXfmSe__"